module.exports = __webpack_public_path__ + "static/media/linkedin.94797786.svg";